<div [ngStyle]="{color: odometerColor()}" #container></div>
